// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__10Fnl","head":"ProcedureTableInfo_head__vR9ZV"};